import mutations from './labHandle.mutations'
import actions from './labHandle.actions'
import getters from './labHandle.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
